const pickText = (...values) => (
  values.find((value) => typeof value === 'string' && value.trim()) || ''
);

const normalizeRows = (value) => (
  Array.isArray(value)
    ? value
      .map((row) => {
        if (!row || typeof row !== 'object') return null;
        return {
          label: pickText(row.label, row.scope, row.setting, row.channel, 'Ajuste'),
          value: pickText(row.recommended_value, row.recommendedValue, row.value, row.action, row.recommendation),
          reason: pickText(row.reason, row.why, row.explanation)
        };
      })
      .filter((row) => row && (row.value || row.reason))
      .slice(0, 6)
    : []
);

const normalizeTrainingSteps = (trainingPlan = {}) => {
  const rawSteps = trainingPlan.steps || trainingPlan.drills || trainingPlan.protocol || [];
  if (!Array.isArray(rawSteps)) return [];
  return rawSteps
    .map((step) => {
      if (typeof step === 'string') return step.trim();
      if (!step || typeof step !== 'object') return '';
      return pickText(step.title, step.name, step.description, step.instruction);
    })
    .filter(Boolean)
    .slice(0, 4);
};

export const renderSensiIaResult = (apiResult = {}) => {
  const diagnosis = apiResult.diagnosis || {};
  const confidence = apiResult.confidence || {};
  const settingsToChange = normalizeRows(apiResult.settings_to_change || apiResult.settingsToChange);
  const settingsToKeep = normalizeRows(apiResult.settings_to_keep || apiResult.settingsToKeep);
  const trainingSteps = normalizeTrainingSteps(apiResult.training_plan || apiResult.trainingPlan);

  return {
    type: 'conversation_result',
    title: 'Diagnostico Sensi-IA',
    summary: pickText(
      diagnosis.summary,
      diagnosis.user_summary,
      apiResult.summary,
      'Use esse diagnostico como ponto de partida e teste em treino curto antes do ranked.'
    ),
    primary: pickText(diagnosis.primary_label, diagnosis.primaryLabel, diagnosis.primary),
    reason: pickText(diagnosis.reason, diagnosis.explanation),
    settingsToChange,
    settingsToKeep,
    trainingSteps,
    sessionId: apiResult.session_id || apiResult.sessionId || null,
    confidenceLabel: pickText(confidence.label, confidence.level, confidence.status),
    nextStep: 'Depois do teste, me diga se melhorou, piorou ou ficou igual para eu refinar com seguranca.'
  };
};

export const renderSensiIaHumanError = ({ status = null, message = null } = {}) => {
  const safeMessage = message && !/^[A-Z0-9_]+$/.test(String(message)) ? message : null;

  if (status === 401) {
    return 'Preciso que voce esteja logado para usar a Sensi-IA.';
  }

  if (status === 403) {
    return safeMessage || 'Seu acesso atual nao permite continuar a Sensi-IA agora. Posso te mostrar os planos ou seguir com outra orientacao.';
  }

  if (status >= 500) {
    return 'A Sensi-IA nao respondeu agora. Tenta novamente em instantes.';
  }

  return safeMessage || 'Nao consegui diagnosticar com esses dados. Me diga o jogo e o que acontece com sua mira.';
};

export default renderSensiIaResult;
